module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-12.dc02d882.mp3";